import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Routes, Route} from 'react-router-dom';
import SoundboardAnimal from './pages/SoundboardAnimal';
import Home from './pages/Home';
import About from './pages/About';
import Reference from './pages/Reference';
import Test from './pages/Test';
import Navbar2 from './components/Navbar2';
import FooterComp from './components/FooterComp';
import SoundboardFruit from './pages/SoundboardFruit';
import FlipbookDogs from './pages/FlipbookDogs';
import FlipbookCats from './pages/FlipbookCats';




function App() {

  
  return (
    
    <BrowserRouter>
        
      <Navbar2 />
      
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/test" element={<Test />} />
          <Route path="/soundboard-animal" element={<SoundboardAnimal />} />
          <Route path="/soundboard-fruit" element={<SoundboardFruit />} />
          <Route path="/flipbook-dogs" element={<FlipbookDogs />} />
          <Route path="/flipbook-cats" element={<FlipbookCats />} />
          <Route path="/reference" element={<Reference />} />
        </Routes>
      
      <FooterComp />
        
    </BrowserRouter>
  );
}

export default App;
